var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 48,
    viewBox: "0 0 163 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.963 48H6.03704C2.71667 48 0 45.3 0 42V6C0 2.7 2.71667 0 6.03704 0H156.963C160.283 0 163 2.7 163 6V42C163 45.3 160.283 48 156.963 48Z",
    fill: "#232931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2552 12.2881C57.2552 13.2961 56.9534 14.1001 56.3497 14.6881C55.6735 15.3961 54.78 15.7561 53.6934 15.7561C52.6429 15.7561 51.7615 15.3961 51.025 14.6761C50.2885 13.9561 49.9263 13.0561 49.9263 12.0001C49.9263 10.9321 50.2885 10.0441 51.025 9.32414C51.7615 8.60414 52.6429 8.24414 53.6934 8.24414C54.2126 8.24414 54.7076 8.34014 55.1785 8.54414C55.6494 8.74814 56.0237 9.01214 56.3135 9.34814L55.6735 9.98414C55.1906 9.42014 54.5386 9.13214 53.6934 9.13214C52.9327 9.13214 52.2686 9.39614 51.7132 9.93614C51.1578 10.4641 50.8801 11.1601 50.8801 12.0121C50.8801 12.8641 51.1578 13.5601 51.7132 14.0881C52.2686 14.6161 52.9327 14.8921 53.6934 14.8921C54.5023 14.8921 55.1785 14.6281 55.7218 14.0881C56.072 13.7401 56.2772 13.2481 56.3255 12.6241H53.6934V11.7481H57.2069C57.2311 11.9401 57.2552 12.1201 57.2552 12.2881Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8214 9.2879H59.5252V11.5679H62.4954V12.4319H59.5252V14.7119H62.8214V15.5999H58.5955V8.3999H62.8214V9.2879Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7454 15.5999H65.8157V9.2879H63.7873V8.3999H68.7618V9.2879H66.7334V15.5999H66.7454Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3719 15.5999V8.3999H73.3016V15.5999H72.3719Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4308 15.5999H76.5011V9.2879H74.4726V8.3999H79.4472V9.2879H77.4187V15.5999H77.4308Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8771 14.6641C88.1647 15.3961 87.2833 15.7561 86.2208 15.7561C85.1583 15.7561 84.2768 15.3961 83.5645 14.6641C82.8521 13.9321 82.502 13.0441 82.502 12.0001C82.502 10.9561 82.8521 10.0561 83.5645 9.33614C84.2768 8.60414 85.1583 8.24414 86.2208 8.24414C87.2712 8.24414 88.1526 8.60414 88.8771 9.33614C89.5894 10.0681 89.9517 10.9561 89.9517 12.0001C89.9396 13.0561 89.5894 13.9441 88.8771 14.6641ZM84.2527 14.0641C84.784 14.6041 85.448 14.8681 86.2208 14.8681C86.9935 14.8681 87.6576 14.6041 88.1888 14.0641C88.7201 13.5241 88.9978 12.8401 88.9978 12.0001C88.9978 11.1601 88.7322 10.4761 88.1888 9.93614C87.6576 9.39614 86.9935 9.12014 86.2208 9.12014C85.448 9.12014 84.784 9.38414 84.2527 9.92414C83.7214 10.4761 83.4437 11.1601 83.4437 12.0001C83.4437 12.8401 83.7214 13.5241 84.2527 14.0641Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2556 15.5999V8.3999H92.3906L95.9162 14.0039H95.9524L95.9162 12.6119V8.3999H96.8459V15.5999H95.88L92.1974 9.7319H92.1612L92.1974 11.1239V15.5999H91.2556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2244 26.0399C79.387 26.0399 77.0688 28.1879 77.0688 31.1399C77.0688 34.0799 79.387 36.2399 82.2244 36.2399C85.0618 36.2399 87.3801 34.0799 87.3801 31.1399C87.3801 28.1879 85.0618 26.0399 82.2244 26.0399ZM82.2244 34.2359C80.6669 34.2359 79.3267 32.9639 79.3267 31.1399C79.3267 29.3039 80.6669 28.0439 82.2244 28.0439C83.782 28.0439 85.1222 29.3039 85.1222 31.1399C85.1222 32.9639 83.7699 34.2359 82.2244 34.2359ZM70.9714 26.0399C68.134 26.0399 65.8158 28.1879 65.8158 31.1399C65.8158 34.0799 68.134 36.2399 70.9714 36.2399C73.8088 36.2399 76.127 34.0799 76.127 31.1399C76.127 28.1879 73.8088 26.0399 70.9714 26.0399ZM70.9714 34.2359C69.4138 34.2359 68.0736 32.9639 68.0736 31.1399C68.0736 29.3039 69.4138 28.0439 70.9714 28.0439C72.529 28.0439 73.8692 29.3039 73.8692 31.1399C73.8692 32.9639 72.529 34.2359 70.9714 34.2359ZM57.5933 27.6119V29.7719H62.8093C62.6524 30.9839 62.2418 31.8839 61.6261 32.4959C60.8654 33.2519 59.6821 34.0799 57.6054 34.0799C54.3937 34.0799 51.8823 31.5119 51.8823 28.3199C51.8823 25.1279 54.3937 22.5599 57.6054 22.5599C59.332 22.5599 60.5998 23.2319 61.5295 24.1079L63.0629 22.5839C61.7589 21.3479 60.0323 20.3999 57.5933 20.3999C53.1984 20.3999 49.5037 23.9519 49.5037 28.3319C49.5037 32.6999 53.1984 36.2639 57.5933 36.2639C59.9719 36.2639 61.7589 35.4959 63.1595 34.0439C64.5963 32.6159 65.043 30.5999 65.043 28.9799C65.043 28.4759 65.0068 28.0079 64.9223 27.6239H57.5933V27.6119ZM112.301 29.2919C111.878 28.1519 110.574 26.0399 107.906 26.0399C105.262 26.0399 103.064 28.1039 103.064 31.1399C103.064 33.9959 105.238 36.2399 108.16 36.2399C110.514 36.2399 111.878 34.8119 112.434 33.9839L110.683 32.8199C110.103 33.6719 109.307 34.2359 108.16 34.2359C107.013 34.2359 106.191 33.7079 105.672 32.6879L112.542 29.8679L112.301 29.2919ZM105.298 30.9959C105.238 29.0279 106.831 28.0199 107.978 28.0199C108.872 28.0199 109.633 28.4639 109.886 29.0999L105.298 30.9959ZM99.7198 35.9399H101.978V20.9399H99.7198V35.9399ZM96.0251 27.1799H95.9406C95.4335 26.5799 94.4676 26.0399 93.236 26.0399C90.6642 26.0399 88.3098 28.2839 88.3098 31.1639C88.3098 34.0199 90.6642 36.2519 93.236 36.2519C94.4555 36.2519 95.4335 35.7119 95.9406 35.0879H96.013V35.8199C96.013 37.7759 94.9626 38.8199 93.2722 38.8199C91.8958 38.8199 91.0385 37.8359 90.6884 37.0079L88.7203 37.8239C89.2878 39.1799 90.785 40.8359 93.2722 40.8359C95.9164 40.8359 98.1502 39.2879 98.1502 35.5199V26.3519H96.013V27.1799H96.0251ZM93.4292 34.2359C91.8716 34.2359 90.5676 32.9399 90.5676 31.1639C90.5676 29.3639 91.8716 28.0559 93.4292 28.0559C94.9626 28.0559 96.17 29.3759 96.17 31.1639C96.1821 32.9399 94.9747 34.2359 93.4292 34.2359ZM122.878 20.9399H117.481V35.9399H119.739V30.2519H122.89C125.389 30.2519 127.84 28.4519 127.84 25.5959C127.84 22.7399 125.365 20.9399 122.878 20.9399ZM122.926 28.1639H119.727V23.0159H122.926C124.617 23.0159 125.57 24.4079 125.57 25.5839C125.57 26.7599 124.617 28.1639 122.926 28.1639ZM136.86 26.0159C135.23 26.0159 133.539 26.7359 132.839 28.3079L134.843 29.1359C135.266 28.3079 136.063 28.0319 136.896 28.0319C138.067 28.0319 139.25 28.7279 139.262 29.9639V30.1199C138.852 29.8919 137.983 29.5439 136.908 29.5439C134.747 29.5439 132.561 30.7199 132.561 32.9159C132.561 34.9199 134.324 36.2159 136.304 36.2159C137.813 36.2159 138.659 35.5439 139.178 34.7519H139.25V35.9159H141.424V30.1679C141.436 27.5039 139.431 26.0159 136.86 26.0159ZM136.582 34.2359C135.845 34.2359 134.819 33.8639 134.819 32.9639C134.819 31.8119 136.099 31.3679 137.21 31.3679C138.2 31.3679 138.671 31.5839 139.262 31.8719C139.093 33.2519 137.886 34.2359 136.582 34.2359ZM149.356 26.3399L146.772 32.8439H146.7L144.02 26.3399H141.593L145.613 35.4359L143.319 40.4879H145.674L151.868 26.3399H149.356ZM129.072 35.9399H131.33V20.9399H129.072V35.9399Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6056 9.04884C12.2555 9.42084 12.0502 9.99684 12.0502 10.7288V37.2728C12.0502 38.0168 12.2555 38.5928 12.6056 38.9528L12.6901 39.0368L27.6499 24.1808V24.0008V23.8208L12.6901 8.96484L12.6056 9.04884Z",
    fill: "url(#paint0_linear_119_4427)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6364 29.1367L27.6498 24.1807V24.0007V23.8207L32.6364 18.8647L32.7451 18.9247L38.6493 22.2607C40.3397 23.2087 40.3397 24.7687 38.6493 25.7287L32.7451 29.0647L32.6364 29.1367Z",
    fill: "url(#paint1_linear_119_4427)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.745 29.076L27.6498 24L12.6055 38.952C13.1609 39.54 14.0785 39.612 15.1169 39.024L32.745 29.076Z",
    fill: "url(#paint2_linear_119_4427)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7448 18.9365L15.1045 8.97647C14.0662 8.38847 13.1485 8.46047 12.5931 9.04847L27.6495 24.0005L32.7448 18.9365Z",
    fill: "url(#paint3_linear_119_4427)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.6364 28.957L15.1048 38.857C14.1268 39.409 13.2454 39.373 12.69 38.869L12.6055 38.953L12.69 39.037C13.2575 39.541 14.1268 39.577 15.1048 39.025L32.745 29.065L32.6364 28.957Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12.6056 38.785C12.2555 38.413 12.0502 37.837 12.0502 37.105V37.285C12.0502 38.029 12.2555 38.605 12.6056 38.965L12.6901 38.881L12.6056 38.785Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M38.6488 25.56L32.6239 28.956L32.7325 29.064L38.6367 25.728C39.4819 25.248 39.9045 24.624 39.9045 24C39.8442 24.564 39.4216 25.128 38.6488 25.56Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.1047 9.14441L38.6491 22.4404C39.4098 22.8724 39.8444 23.4244 39.9169 24.0004C39.9169 23.3764 39.4943 22.7404 38.6491 22.2724L15.1047 8.97641C13.4143 8.02841 12.0379 8.82041 12.0379 10.7404V10.9204C12.0379 8.98841 13.4264 8.19641 15.1047 9.14441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_4427",
    x1: 26.3213,
    y1: 10.4526,
    x2: 6.18277,
    y2: 30.7154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_4427",
    x1: 40.852,
    y1: 24.0025,
    x2: 11.6365,
    y2: 24.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_119_4427",
    x1: 29.9763,
    y1: 26.7554,
    x2: 2.66688,
    y2: 54.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_119_4427",
    x1: 8.81057,
    y1: 0.212034,
    x2: 21.0055,
    y2: 12.4821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.7be9376b21d2a5024617a8fc44c3f53a.svg";
export { ForwardRef as ReactComponent };